import { inject, Service } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Service()
export class LocaleService {
  private _translate = inject(TranslateService);
  get currentLocale(): string {
    //TODO: verificare che il funzionamento sia corretto
    // return this._translate.currentLang;
    return this._translate.getCurrentLang();
  }
}
